/* ==========================================================================
   lbl-scroll-nav — Progress-Indicator (Vanilla, Auto-Discovery)
   Findet Nav-Punkte zur Laufzeit über [data-coffee-nav] im DOM (keine feste
   Liste, keine festen IDs). Desktop = seitliche Text-/Punkt-Leiste,
   Mobile = Pille + Bottom-Sheet. Port von scroll-nav.jsx (React-Prototyp).
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-lbl-scrollnav]');
    if (!root) return;

    // --- Nav-Punkte aus dem DOM einsammeln (Reihenfolge = Dokument-Reihenfolge) ---
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-coffee-nav]'));
    var sections = targets.map(function (el) {
      return { el: el, label: el.getAttribute('data-coffee-nav') || '' };
    });
    // Weniger als 2 Punkte → Indicator ergibt keinen Sinn
    if (sections.length < 2) { root.remove(); return; }

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var darkEls = Array.prototype.slice.call(document.querySelectorAll('[data-coffee-nav-dark]'));
    var footerEl = document.querySelector('.footer, .section-footer, footer[role="contentinfo"], [data-coffee-nav-footer]');

    // ---------- Markup bauen ----------
    var SVG = 'http://www.w3.org/2000/svg';
    function svg(paths, cls) {
      var s = document.createElementNS(SVG, 'svg');
      s.setAttribute('viewBox', '0 0 24 24');
      s.setAttribute('aria-hidden', 'true');
      if (cls) s.setAttribute('class', cls);
      paths.forEach(function (d) {
        var p = document.createElementNS(SVG, 'path');
        p.setAttribute('d', d);
        s.appendChild(p);
      });
      return s;
    }

    // Desktop-Rail
    var rail = document.createElement('nav');
    rail.className = 'lbl-sn-rail';
    rail.setAttribute('aria-label', 'Seitenfortschritt');
    var railUl = document.createElement('ul');
    var railItems = [];
    sections.forEach(function (sec, i) {
      var li = document.createElement('li');
      li.className = 'lbl-sn-item';
      var a = document.createElement('a');
      a.href = '#';
      a.innerHTML = '<span class="lbl-sn-mark" aria-hidden="true"></span><span class="lbl-sn-txt"></span>';
      a.querySelector('.lbl-sn-txt').textContent = sec.label;
      a.addEventListener('click', function (e) { e.preventDefault(); jumpTo(sec.el); });
      li.appendChild(a);
      railUl.appendChild(li);
      railItems.push({ li: li, a: a });
    });
    rail.appendChild(railUl);

    // Mobile-Pille + Sheet
    var pill = document.createElement('button');
    pill.className = 'lbl-sn-pill';
    pill.type = 'button';
    pill.setAttribute('aria-haspopup', 'dialog');
    pill.setAttribute('aria-expanded', 'false');
    pill.innerHTML =
      '<span class="lbl-sn-ringwrap">' +
        '<svg class="lbl-sn-ring" viewBox="0 0 28 28" aria-hidden="true">' +
          '<circle cx="14" cy="14" r="11" class="bg"></circle>' +
          '<circle cx="14" cy="14" r="11" class="fg" transform="rotate(-90 14 14)"></circle>' +
        '</svg>' +
        '<span class="lbl-sn-pct">0</span>' +
      '</span>' +
      '<span class="lbl-sn-pill-name"></span>' +
      '<span class="lbl-sn-pill-count"></span>';
    var ringFg = pill.querySelector('.fg');
    var ringR = 11, ringC = 2 * Math.PI * ringR;
    ringFg.setAttribute('stroke-dasharray', ringC);
    ringFg.setAttribute('stroke-dashoffset', ringC);

    var sheetWrap = document.createElement('div');
    sheetWrap.className = 'lbl-sn-sheet-wrap';
    sheetWrap.hidden = true;
    sheetWrap.innerHTML =
      '<div class="lbl-sn-scrim"></div>' +
      '<div class="lbl-sn-sheet" role="dialog" aria-modal="true" aria-label="Sektionen auf der Seite">' +
        '<div class="lbl-sn-sheet-hd"><span>Auf der Seite</span>' +
          '<button class="lbl-sn-sheet-x" type="button" aria-label="Schließen">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<ul class="lbl-sn-sheet-list"></ul>' +
      '</div>';
    var sheetList = sheetWrap.querySelector('.lbl-sn-sheet-list');
    var sheetItems = [];
    sections.forEach(function (sec, i) {
      var li = document.createElement('li');
      li.className = 'lbl-sn-srow';
      var a = document.createElement('a');
      a.href = '#';
      a.innerHTML = '<span class="lbl-sn-srow-lbl"></span>';
      a.querySelector('.lbl-sn-srow-lbl').textContent = sec.label;
      a.addEventListener('click', function (e) { e.preventDefault(); jumpTo(sec.el); closeSheet(); });
      li.appendChild(a);
      sheetList.appendChild(li);
      sheetItems.push({ li: li, a: a });
    });

    root.appendChild(rail);
    root.appendChild(pill);
    root.appendChild(sheetWrap);

    // ---------- Sheet öffnen/schließen ----------
    var lastFocus = null;
    function openSheet() {
      lastFocus = document.activeElement;
      sheetWrap.hidden = false;
      pill.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', onKey);
      var x = sheetWrap.querySelector('.lbl-sn-sheet-x');
      if (x) x.focus();
    }
    function closeSheet() {
      sheetWrap.hidden = true;
      pill.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') { closeSheet(); return; }
      if (e.key === 'Tab') {
        // einfache Fokus-Falle im Sheet
        var focusables = sheetWrap.querySelectorAll('button, a[href]');
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    pill.addEventListener('click', openSheet);
    sheetWrap.querySelector('.lbl-sn-scrim').addEventListener('click', closeSheet);
    sheetWrap.querySelector('.lbl-sn-sheet-x').addEventListener('click', closeSheet);

    function jumpTo(el) {
      /* Abstand zum fixed Header aus der gemessenen Hoehe, nicht aus einer
         festen Zahl: 88px stimmten nur mobil, auf dem Desktop ist der Header
         212px hoch und das Sprungziel landete darunter. --header-group-height
         schreibt critical.js, aktuell gehalten vom ResizeObserver in
         header.js. Der Fallback greift nur, falls die Variable fehlt. */
      var headerH = parseFloat(
        getComputedStyle(document.body).getPropertyValue('--header-group-height')
      ) || 88;
      var top = el.getBoundingClientRect().top + window.pageYOffset - headerH;
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    // ---------- Scroll-Spy ----------
    var pillName = pill.querySelector('.lbl-sn-pill-name');
    var pillCount = pill.querySelector('.lbl-sn-pill-count');
    var pillPct = pill.querySelector('.lbl-sn-pct');
    var prev = { a: -1, p: -1, dark: null, on: null, hidden: false };
    var lastY = window.pageYOffset || 0;

    function setActive(idx) {
      railItems.forEach(function (it, i) {
        it.li.classList.toggle('is-done', i < idx);
        it.li.classList.toggle('is-current', i === idx);
        it.a.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
      sheetItems.forEach(function (it, i) {
        it.li.classList.toggle('is-done', i < idx);
        it.li.classList.toggle('is-current', i === idx);
        it.a.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
      pillName.textContent = sections[idx].label;
      pillCount.textContent = (idx + 1) + '/' + sections.length;
    }

    function update() {
      var y = window.pageYOffset || 0;
      var vh = window.innerHeight;
      var max = document.documentElement.scrollHeight - vh;
      var p = max > 0 ? Math.min(1, Math.max(0, y / max)) : 0;

      // aktive Sektion = letzte, deren Oberkante die 42%-Linie passiert hat
      var line = vh * 0.42;
      var idx = 0;
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].el.getBoundingClientRect().top <= line) idx = i;
      }
      if (p > 0.985) idx = sections.length - 1;

      // Farbumschlag: dunkle Section auf Höhe der Viewport-Mitte?
      var cy = vh / 2, dark = false;
      for (var d = 0; d < darkEls.length; d++) {
        var r = darkEls[d].getBoundingClientRect();
        if (r.top <= cy && r.bottom >= cy) { dark = true; break; }
      }

      // Lebenszyklus: nach ~halber erster Sektion ein, vor Footer aus
      var first = sections[0].el;
      var firstH = first ? first.offsetHeight : vh;
      var footerTop = footerEl ? footerEl.getBoundingClientRect().top : Infinity;
      var on = y > firstH * 0.5 && footerTop > vh + 40;

      // Pille: hide-on-down / show-on-up
      var dy = y - lastY;
      var hidden = prev.hidden;
      if (y < 120) hidden = false;
      else if (dy > 6) hidden = true;
      else if (dy < -6) hidden = false;
      lastY = y;

      if (idx !== prev.a) { prev.a = idx; setActive(idx); }
      if (p !== prev.p) {
        prev.p = p;
        ringFg.setAttribute('stroke-dashoffset', ringC * (1 - p));
        pillPct.textContent = Math.round(p * 100);
      }
      if (dark !== prev.dark) { prev.dark = dark; root.classList.toggle('on-dark', dark); }
      if (on !== prev.on) { prev.on = on; root.classList.toggle('is-on', on); }
      if (hidden !== prev.hidden) { prev.hidden = hidden; root.classList.toggle('is-hidden', hidden); }
    }

    var lastRun = 0;
    function run() {
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      if (now - lastRun < 60) return;
      lastRun = now;
      update();
    }
    window.addEventListener('scroll', run, { passive: true });
    window.addEventListener('resize', run, { passive: true });
    var iv = setInterval(update, 200);
    update();

    // Im Theme-Editor (Section neu gerendert) sauber aufräumen
    document.addEventListener('shopify:section:unload', function () {
      window.removeEventListener('scroll', run);
      window.removeEventListener('resize', run);
      clearInterval(iv);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
